import React, { useEffect, useState } from 'react';
import { Button,Container, IconButton, Grid, FormGroup, TextField, Typography, FormHelperText,FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal } from '@mui/material';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { Delete, Add } from "@mui/icons-material";
import api from './api'; // api.js をインポート
import PdfModalViewer from './PdfModalViewer.js';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import { useNavigationHistory } from './common/navigationHistory.js';
import BackButton from './common/BackButton.js';
import HamburgerMenu from './components/Hamburger.jsx';
import Header from "./components/Header.jsx";

const Comp17Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
    const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null); 
    const [mypageData, setMypageData] = useState(null);
    console.log(mypageData)
    const navigate = useNavigate();
    const location = useLocation();
    const [notApply, setNotApply] = useState(false);
    const createGoodsDetail = () => ({
      goods_item: '',
      goods_price: '',
      goods_quantity: '',
      goods_price_all: '',
    });
    const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
    const [formData, setFormData] = useState({
      user_17_name: "",
      user_17_department: "",
      user_17_phone: "",
      user_17_tel: "",
      onsite_manager_company: '',
      onsite_manager_name: '',
      onsite_manager_phone: '',
      good_price_all_contains: '',
      post_event_sales_responsible: '',
      post_event_manager_company: '',
      post_event_manager_name: '',
      post_event_manager_phone: '',
      alfa_text: '',
      survey: false,
      novelty: false,
      details: [createGoodsDetail()]
    });
    const [corrections, setCorrections] = useState({
      user_17_info: false,
      onsite_manager_info: false,
      post_manager_info: false,
      details: false,
    });
    const field_name_map = {
      user_17_info: "担当者情報",
      onsite_manager_info: "現場管理責任者情報",
      post_manager_info: "会期後管理責任者情報",
      details: "販売物品詳細",
    };
    const [open, setOpen] = useState(false);
    const [memoText, setMemoText] = useState('');

    const handleCorrectionChange = (fieldKey) => (e) => {
      setCorrections(prev => ({
        ...prev,
        [fieldKey]: e.target.checked
      }));
    };

    const updateStatus = (exhibitorId, formType, updates) => {
      setExhibitors((prev) =>
        prev.map((ex) =>
          ex.exhibitor_id === exhibitorId
            ? {
                ...ex,
                ...Object.fromEntries(
                  Object.entries(updates).map(([role, status]) => [
                    `${formType}_${role}_status`,
                    status,
                  ])
                ),
              }
            : ex
        )
      );
    };

    const handleCorrection = async () => {
      try {
        const selectedFields = Object.entries(corrections)
          .filter(([_, checked]) => checked)
          .map(([field]) => field_name_map[field] || field);

        if (selectedFields.length === 0) {
          alert('修正対象の項目を選択してください');
          return;
        }

        const currentPath = window.location.pathname;

        await api.patch('/api/host-correction', {
          exhibitor_id: exhibitorId,
          form_type: 'o17',
          correction: selectedFields,
          memo: memoText,
          current_path: currentPath,
        });

        // 👇 これ追加
        updateStatus(exhibitorId, 'o17', {
          host: '未確認',
          corporate: '未確認',
        });

        alert('修正リクエスト送信完了');
        setFormModalOpen(false);

        setCorrections(
          Object.fromEntries(Object.keys(corrections).map(k => [k, false]))
        );
        setMemoText('');

      } catch (err) {
        console.error(err);
        alert('修正処理でエラーが発生しました');
      }
    };

    const updateHostStatus = (exhibitorId, formType, newStatus) => {
      setExhibitors((prev) =>
        prev.map((ex) =>
          ex.exhibitor_id === exhibitorId
            ? {
                ...ex,
                [`${formType}_host_status`]: newStatus,
                [`${formType}_corporate_status`]: newStatus, // ←これ追加
              }
            : ex
        )
      );
    };

    // 確認済み
    const handleConfirm = async () => {
      try {
        const res = await api.patch('/api/forms/confirm', {
          exhibitor_id: exhibitorId,
          form_type: selectedFormKey,
          role: "host"
        });
        
        updateHostStatus(exhibitorId, selectedFormKey,'確認済');

        alert('確認済みに更新しました');
        setFormModalOpen(false);
      } catch (err) {
        console.error(err);
        alert('確認処理でエラー');
      }

      console.log('送信データ', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });
    };

    useEffect(() => {
      if ((isModal || isCorpModal) && propExhibitorId) {
        setExhibitorId(propExhibitorId);
        return;
      }
  
      const userData = localStorage.getItem("user");
  
      if (userData) {
        const parsedUser = JSON.parse(userData);
        if (parsedUser?.exhibitor_id) {
          setExhibitorId(parsedUser.exhibitor_id);
        } else {
          console.warn("exhibitor_id が見つかりません");
        }
      } else {
        console.warn("localStorageにuserが存在しません");
      }
    }, [location, isModal, isCorpModal, propExhibitorId]);

    const [sameAsExhibitor, setSameAsExhibitor] = useState("different");  
    
    const handleChange = (field) => (e) => {
      let value =
        e.target.type === "checkbox"
          ? e.target.checked
          : e.target.value;

      if (value === "true") value = true;
      if (value === "false") value = false;

      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

    const [checked, setChecked] = useState({
      goods: false,
      novel: false,
      anc: false,
    });

    const handleCheckedChange = (e) => {
      const { name, checked: value } = e.target;

      setChecked((prev) => ({ ...prev, [name]: value }));

      if (!value) {
        setFormData((prev) => {
          let resetFields = {};

          if (name === "goods") {
            resetFields = {
              onsite_manager_company: '',
              onsite_manager_name: '',
              onsite_manager_phone: '',
              good_price_all_contains: '',
              post_event_sales_responsible: '',
              post_event_manager_company: '',
              post_event_manager_name: '',
              post_event_manager_phone: '',
              details: [createGoodsDetail()]
            };
          }

          if (name === "anc") {
            resetFields = {
              survey: null,
            };
          }

          if (name === "novel") {
            resetFields = {
              novelty: null,
            };
          }

          return { ...prev, ...resetFields };
        });
      }
    };

    const [formErrors, setFormErrors] = useState({}); // フィールドごとのエラーを保持

    const isInteger = (val) => /^[0-9]+$/.test(val);

    const handleArrayChange = (key, index, field, value) => {
      const updated = [...formData[key]];
      let errorMsg = "";

      // 数値フィールドのときだけ整数チェック
      if (["goods_price", "goods_quantity"].includes(field)) {
        if (value === "" || isInteger(value)) {
          // OK → 数値化（空文字は空のまま）
          updated[index][field] = value === "" ? "" : Number(value);
        } else {
          // NG → 値はそのまま保持してエラーメッセージ
          updated[index][field] = value;
          errorMsg = "半角数字（整数）のみ入力してください";
        }
      } else {
        // 文字列系フィールドはそのまま
        updated[index][field] = value;
      }

      // 合計を自動計算
      if (
        key === "details" &&
        ["goods_price", "goods_quantity"].includes(field)
      ) {
        const price = Number(updated[index].goods_price) || 0;
        const quantity = Number(updated[index].goods_quantity) || 0;

        updated[index].goods_price_all =
          price === 0 || quantity === 0 ? "" : price * quantity;
      }

      setFormData({
        ...formData,
        [key]: updated,
      });

      // エラーを更新
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        if (errorMsg) {
          newErrors[`${key}_${index}_${field}`] = errorMsg;
        } else {
          delete newErrors[`${key}_${index}_${field}`];
        }
        return newErrors;
      });
    };

    const handleAdd = (key, initial = {}) => {
      setFormData({ ...formData, [key]: [...formData[key], initial] });
    };

    const handleDelete = (key, index) => {
      const updated = [...formData[key]];
      updated.splice(index, 1);
      setFormData({ ...formData, [key]: updated });
    };

    useEffect(() => {
      const fetchData = async () => {
        try {
          const user = JSON.parse(localStorage.getItem('user'));
          const res = await api.get(`/api/mypage/${exhibitorId}`);
          setMypageData(res.data);
        } catch (err) {
          console.error("データ取得エラー:", err);
        }
      };
      fetchData();
    }, []);

    const [fieldsDisabled, setFieldsDisabled] = useState(false);

    const handleSameAsExhibitor = (value) => {
      setSameAsExhibitor(value);

      if (value === "same") {
        // 出展者情報コピー
        setFormData((prev) => ({
          ...prev,
          user_17_name: mypageData.user_name || "",
          user_17_department: mypageData.department || "",
          user_17_phone: mypageData.phone_number || "",
          user_17_tel: mypageData.tel_number || "",
        }));
        setFieldsDisabled(true);
      } else if (value === "different") {
        // フィールドを空にする
        setFormData((prev) => ({
          ...prev,
          user_17_name: "",
          user_17_department: "",
          user_17_phone: "",
          user_17_tel: "",
        }));
        setFieldsDisabled(false);
      }
    };
    // Comp17fetch
   useEffect(() => {
    const fetchO17InitialData = async () => {
        try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO17, resMypage] = await Promise.all([
            api.get(`/api/submission-status/${exhibitorId}`),
            api.get(`/api/o17submission/${exhibitorId}`),
            api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o17Status = resStatus.data?.o17_status || "";
        const o17Data = resO17.data || {};
        const mypage = resMypage.data || {};

        if (o17Status === "申請しない") {
            setNotApply(true);
            setFormData({
            user_17_name: null,
            user_17_department: null,
            user_17_phone: null,
            user_17_tel: null,
            onsite_manager_company: null,
            onsite_manager_name: null,
            onsite_manager_phone: null,
            goods_price_all_contains: null,
            post_event_sales_responsible: null,
            post_event_manager_company: null,
            post_event_manager_name: null,
            post_event_manager_phone: null,
            alfa_text: null,
            survey: false,
            novelty: false,
            details: [createGoodsDetail()],          
            });
        } else {
            if (Object.values(o17Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
            })) {
            setFormData(prev => ({
                ...prev,
                ...o17Data,
                details: o17Data.details?.length ? o17Data.details : [createGoodsDetail()],
            }));
            if (
              o17Data.user_17_name === mypage.user_name &&
              o17Data.user_17_department === mypage.department &&
              o17Data.user_17_phone === mypage.phone_number &&
              o17Data.user_17_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
              // pack の条件
              const hasGoods =
                !!o17Data.post_event_manager_company ||
                !!o17Data.onsite_manager_company ||
                (Array.isArray(o17Data.details) &&
                  o17Data.details.some(
                    (item) =>
                      item?.goods_item ||
                      item?.goods_price ||
                      item?.goods_quantity ||
                      item?.goods_price_all
                  ));

              // storage の条件
              const hasAnc =
                o17Data.survey === true;
              const hasNovel = 
                o17Data.novelty === true;
              setChecked({
                goods: !!hasGoods,
                anc: !!hasAnc,
                novel: !!hasNovel,
              });
            }

            setNotApply(false);
        }

        } catch (err) {
        console.error("O17初期データ取得エラー:", err);
        }
    };

    fetchO17InitialData();
    }, []);

    const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_17_name: '',
            user_17_department: '',
            user_17_phone: '',
            user_17_tel: '',
            onsite_manager_company: '',
            onsite_manager_name: '',
            onsite_manager_phone: '',
            goods_price_all_contains: '',
            post_event_sales_responsible: '',
            post_event_manager_company: '',
            post_event_manager_name: '',
            post_event_manager_phone: '',
            survey: false,
            novelty: false,
            alfa_text: '',
            details: [createGoodsDetail()],
          });
      }
  };

  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
    // { label: 'INDEX', path: '/INDEX.pdf' },
    { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
    // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
    // { label: '出展者証について', path: '/出展者証について.pdf' },
    // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
    // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
    // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
    // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
    // { label: '出展者一覧', path: '/出展者一覧.pdf' },
    // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
    // { label: '運送関連', path: '/運送関連.zip' },
    // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
    // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
  ];

  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );

  const [noticeModalOpen, setNoticeModalOpen] = useState(false);
  const [ submitErrors, setSubmitErrors] = useState({});

  const [openPop, setOpenPop] = useState(false);

  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
      }

      const sanitizeFormData = (data) => {
        if (Array.isArray(data)) {
          return data.map(sanitizeFormData);
        } else if (typeof data === "object" && data !== null) {
          const newObj = {};
          for (const [key, value] of Object.entries(data)) {
            if (value === "") {
              newObj[key] = null;
            }
            // --- 数値フィールド ---
            else if (
              [
                "goods_price_all_contains",
                "goods_price",
                "goods_quantity",
                "goods_price_all",
              ].includes(key)
            ) {
              newObj[key] =
                value !== null && value !== "" && !isNaN(Number(value))
                  ? Number(value)
                  : null;
            }
            // --- 文字列フィールド ---
            else if (
              [
                "user_17_name",
                "user_17_department",
                "user_17_phone",
                "user_17_tel",
                "onsite_manager_company",
                "onsite_manager_name",
                "onsite_manager_phone",
                "post_event_sales_responsible",
                "post_event_manager_company",
                "post_event_manager_name",
                "post_event_manager_phone",
                "alfa_text",
                "goods_item",
              ].includes(key)
            ) {
              newObj[key] = value != null ? String(value) : null;
            }
            // --- 再帰 ---
            else {
              newObj[key] = sanitizeFormData(value);
            }
          }
          return newObj;
        }
        return data;
      };

      // 合計金額を計算
      const totalAmount = formData.details.reduce((sum, item) => {
        return sum + (Number(item.goods_price_all) || 0);
      }, 0);

      // formDataにセット
      const submitData = {
        ...formData,
        goods_price_all_contains: totalAmount,
      };

      const normalizedDetails = (formData.details || []).filter(
        (item) =>
          item?.goods_item?.trim() ||
          item?.goods_price !== '' ||
          item?.goods_quantity !== ''
      );

      // サニタイズ
      const sanitizedFormData = sanitizeFormData({
        ...submitData,
        details: normalizedDetails,
        onsite_manager_company: checked.goods ? submitData.onsite_manager_company : '',
        onsite_manager_name: checked.goods ? submitData.onsite_manager_name : '',
        onsite_manager_phone: checked.goods ? submitData.onsite_manager_phone : '',
      });

      const submitErrors = {};

      if (!notApply) {
        // 基本必須項目チェック
        if (!formData.user_17_name?.trim())
          submitErrors.user_17_name = "入力してください";
        if (!formData.user_17_phone?.trim())
          submitErrors.user_17_phone = "入力してください";
        if (!formData.user_17_tel?.trim())
          submitErrors.user_17_tel = "入力してください";
        if (!checked.goods && !checked.anc && !checked.novel) {
          submitErrors.checked = "いずれか1つを選択してください";
        }
        if (checked.goods) {
          if (!formData.onsite_manager_company?.trim()) {
            submitErrors.onsite_manager_company = "入力してください";
          }
          if (!formData.onsite_manager_name?.trim()) {
            submitErrors.onsite_manager_name = "入力してください";
          }
          if (!formData.onsite_manager_phone?.trim()) {
            submitErrors.onsite_manager_phone = "入力してください";
          }
          // if (!normalizedDetails.length) {
          //   submitErrors.details = "物品販売を1件以上入力してください";
          // }
        }
      }

      const fieldDisplayNames = {
        user_17_name: "担当者名",
        user_17_department: "担当部署",
        user_17_phone: "担当者携帯",
        user_17_tel: "担当者電話",
        checked: "申込区分",
        onsite_manager_company: "現場管理責任者会社名",
        onsite_manager_name: "現場管理責任者名",
        onsite_manager_phone: "現場管理責任者電話番号",
        details: "物品販売の申込",
      };

      if (Object.keys(submitErrors).length > 0) {
        setSubmitErrors(submitErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const errorMessages = Object.entries(submitErrors)
          .map(
            ([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`
          )
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const payload = {
        exhibitor_id: exhibitorId,
        formData: sanitizedFormData,
        notApply: notApply,
      };

      console.log(payload)

      const res = await api.post("/api/submit-o17", payload);
      
      if (res.status === 200) {
        alert("保存成功");
      } else {
        alert("保存失敗");
      }

      setTimeout(() => {
        if (isModal) {
          setFormModalOpen(false);
        } else {
          if (user?.user_id === 0) {
            navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
          } else {
            navigate(`/mypage/${user?.mypage_id}`);
          }
        }
      }, 1000);
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };
  const user = JSON.parse(localStorage.getItem("user"));
  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://sdgs.ex-link.net'; // 本番 HTTPS
  return(

    <>
    <div sx={{mx: 0, px: 0 , width: '100%'}}>
      {!isCorpModal &&(
        <Header
          title="SDGs 子ども・ユースフェア2026 防炎対象物品申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
      {`
      @media only screen and (max-width: 560px) {
      .sm-block {display: block;}
      .sm-none {display: none;}
      .sm-column {flex-direction: column;}
      .noti-cate {font-size: 18px;}
      .timestamp {font-size: 14px;}
      .info {font-size: 14px;}
      .f-17 {font-size: 17px;}
      }
      @media only screen and (min-width: 561px) {
      .hamburger_menu_btn_wrap {display: none;}
      }
      `}
      </style>
      <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
                className={`menu-item`}
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #00111BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#00111bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Typography variant="h6" gutterBottom>
              修正内容のメモ
            </Typography>
            <TextField
              multiline
              rows={20}
              fullWidth
              placeholder="ここに修正内容を書いてください..."
              value={memoText}
              onChange={(e) => setMemoText(e.target.value)}
            />
            <Box>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
          <Typography variant="h6">物品販売・アンケート・ノベルティ配布申込</Typography>
          <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />
          <FormControl
            required
            error={!!submitErrors.water}   // エラー状態をここで反映
            component="fieldset"
            variant="standard"
          >
          <FormGroup row>
              <FormControlLabel
              control={<Checkbox name="goods" checked={checked.goods} onChange={handleCheckedChange} />}
              label="物品販売の申込"
              />
              <FormControlLabel
              control={<Checkbox name="anc" checked={checked.anc} onChange={handleCheckedChange} />}
              label="アンケートの申込"
              />
              <FormControlLabel
              control={<Checkbox name="novel" checked={checked.novel} onChange={handleCheckedChange} />}
              label="ノベルティ配布の申込"
              />
          </FormGroup>
          <FormHelperText>
            {submitErrors.goods || submitErrors.anc || submitErrors.novel}
          </FormHelperText>
          </FormControl>

      {!notApply && (
            <>
            <Box>
              {!!changeModalOpen &&(
              <FormControlLabel
                  control={
                    <Checkbox
                      checked={corrections.user_17_info}
                      onChange={handleCorrectionChange('user_17_info')}
                      sx={{
                  color: 'red', // 未チェック時の枠の色
                  '&.Mui-checked': {
                    color: 'red', // チェック時の色
                  },
                }}
                    />
                  }
                  label="担当者情報"
                />
              )}
              <Typography variant="h6" gutterBottom>
              担当者情報
              </Typography>
              <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
              <FormControl component="fieldset">
              <FormLabel component="legend">出展申込時の担当者と</FormLabel>
              <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                  <FormControlLabel value="same" control={<Radio />} label="同じ" />
                  <FormControlLabel value="different" control={<Radio />} label="異なる" />
              </RadioGroup>
              </FormControl>
              <Grid container spacing={2}>
              <Grid size={6}><TextField fullWidth label="氏名" name="user_17_name" value={formData.user_17_name} disabled={fieldsDisabled} onChange={handleChange("user_17_name")} error={!!submitErrors.user_17_name} helperText={submitErrors.user_17_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
              <Grid size={6}><TextField fullWidth label="部署" name="user_17_department" value={formData.user_17_department} disabled={fieldsDisabled} onChange={handleChange("user_17_department")} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
              <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_17_phone" value={formData.user_17_phone} disabled={fieldsDisabled} onChange={handleChange("user_17_phone")} error={!!submitErrors.user_17_phone} helperText={submitErrors.user_17_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
              <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_17_tel" value={formData.user_17_tel} disabled={fieldsDisabled} onChange={handleChange("user_17_tel")} error={!!submitErrors.user_17_tel} helperText={submitErrors.user_17_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
              </Grid>
              <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>
              {checked.goods && (
              <Box>
                <Typography variant="p">現場管理責任者</Typography>

                <TextField
                    label="会社名"
                    name="onsite_manager_company"
                    value={formData.onsite_manager_company}
                    onChange={handleChange("onsite_manager_company")}
                    fullWidth
                    sx={{ mb: 2 }}
                    error={!!submitErrors.onsite_manager_company}
                    helperText={submitErrors.onsite_manager_company}
                />

                <TextField
                    label="担当者名"
                    name="onsite_manager_name"
                    value={formData.onsite_manager_name}
                    onChange={handleChange("onsite_manager_name")}
                    fullWidth
                    sx={{ mb: 2 }}
                    error={!!submitErrors.onsite_manager_name}
                    helperText={submitErrors.onsite_manager_name}
                />

                <TextField
                  label="電話番号"
                  name="onsite_manager_phone"
                  value={formData.onsite_manager_phone}
                  onChange={handleChange("onsite_manager_phone")}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!submitErrors.onsite_manager_phone}
                  helperText={submitErrors.onsite_manager_phone}
                />
              </Box>
              )}
              {checked.goods && (
              <>
              <Box>
              {!!changeModalOpen &&(
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={corrections.details}
                      onChange={handleCorrectionChange('details')}
                      sx={{
                  color: 'red', // 未チェック時の枠の色
                  '&.Mui-checked': {
                    color: 'red', // チェック時の色
                  },
                }}
                    />
                  }
                  label="販売物品詳細"
                />
              )}
              <Typography variant='h6'>物品販売申込（食品以外）</Typography>

              <Typography>販売する物品の詳細を入力してください。</Typography>
              <Typography color='error'>※食品の販売を希望する出展者は「食品取扱関係調査票・食品販売申込」より申請してください。</Typography>

              {formData.details.map((item, index) => (
                <React.Fragment key={index}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                        <TableCell>品名</TableCell>
                        <TableCell>価格</TableCell>
                        <TableCell>数量</TableCell>
                        <TableCell>合計</TableCell>
                        </TableRow>
                    </TableHead>

                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <TextField
                              value={item.goods_item}
                              onChange={(e) =>
                                handleArrayChange(
                                  "details",
                                  index,
                                  "goods_item",
                                  e.target.value
                                )
                              }
                              fullWidth
                              sx={{ mb: 2 }}
                              error={!!formErrors[`details_${index}_goods_item`]}
                              helperText={formErrors[`details_${index}_goods_item`]}
                            />
                          </TableCell>

                          <TableCell>
                            <TextField
                              value={item.goods_price}
                              onChange={(e) =>
                                handleArrayChange(
                                  "details",
                                  index,
                                  "goods_price",
                                  e.target.value
                                )
                              }
                              fullWidth
                              sx={{ mb: 2 }}
                              error={!!formErrors[`details_${index}_goods_price`]}
                              helperText={
                                formErrors[`details_${index}_goods_price`]
                              }
                            />
                          </TableCell>

                          <TableCell>
                            <TextField
                              value={item.goods_quantity}
                              onChange={(e) =>
                                handleArrayChange(
                                  "details",
                                  index,
                                  "goods_quantity",
                                  e.target.value
                                )
                              }
                              fullWidth
                              sx={{ mb: 2 }}
                              error={!!formErrors[`details_${index}_goods_quantity`]}
                              helperText={
                                formErrors[`details_${index}_goods_quantity`]
                              }
                            />
                          </TableCell>

                          <TableCell>
                            <TextField
                              value={item.goods_price_all}
                              fullWidth
                              sx={{ mb: 2 }}
                              slotProps={{
                                input: {
                                  readOnly: true,
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {formData.details.length >= 1 && (
                    <IconButton
                      onClick={() => handleDelete("details", index)}
                    >
                      <Delete />
                    </IconButton>
                  )}
                </React.Fragment>
              ))}

              <Button
                onClick={() =>
                  handleAdd("details", {
                    goods_item: "",
                    goods_price: "",
                    goods_quantity: "",
                    goods_price_all: "",
                  })
                }
                startIcon={<Add />}
              >
                追加
              </Button>
              </Box>

              <Box>
              <FormControl component="fieldset" sx={{ mt: 3 }} error={!!submitErrors.post_event_sales_responsible}>
                  <FormLabel component="legend">会期後販売責任者</FormLabel>
                  <RadioGroup
                  row
                  name="post_event_sales_responsible"
                  value={formData.post_event_sales_responsible}
                  onChange={handleChange("post_event_sales_responsible")}
                  >
                  {["現場管理責任者と同一", "現場管理責任者と異なる者"].map((plan) => (
                      <FormControlLabel key={plan} value={plan} control={<Radio />} label={plan} />
                  ))}
                  </RadioGroup>
                  {!!submitErrors.post_event_sales_responsible && (
                    <FormHelperText>{submitErrors.post_event_sales_responsible}</FormHelperText>
                  )}
              </FormControl>
              </Box>
              
              {formData.post_event_sales_responsible === "現場管理責任者と異なる者" && (
              <Box>
              <TextField
                  label="会社名"
                  name="post_event_manager_company"
                  value={formData.post_event_manager_company}
                  onChange={handleChange("post_event_manager_company")}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!submitErrors.post_event_manager_company}
                  helperText={submitErrors.post_event_manager_company}
              />

              <TextField
                  label="担当者名"
                  name="post_event_manager_name"
                  value={formData.post_event_manager_name}
                  onChange={handleChange("post_event_manager_name")}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!submitErrors.post_event_manager_name}
                  helperText={submitErrors.post_event_manager_name}
              />

              <TextField
                  label="電話番号"
                  name="post_event_manager_phone"
                  value={formData.post_event_manager_phone}
                  onChange={handleChange("post_event_manager_phone")}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!submitErrors.post_event_manager_phone}
                  helperText={submitErrors.post_event_manager_phone}
              />
              <Typography color='error'>※コピー商品など、商標権、知的所有権および財産権を侵害するものは厳禁となります。</Typography>
              </Box>
              )}
              </>
              )}
          </Box>
          {checked.anc && (
            <Box>
              <Typography variant="h6">アンケート申込</Typography>

              <Typography>
                【アンケート実施に関する規約】
                <br />
                ・アンケートを実施者以外に譲渡しない。
                <br />
                ・アンケート記名者と実施者は会期後も絶対にトラブルを起こさない。
                <br />
                ・アンケートの実施は各自の小間内で行う。
              </Typography>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.survey}
                    onChange={handleChange("survey")}
                  />
                }
                label="上記規約を守り、実施いたします。"
                sx={{ mt: 1 }}
              />
            </Box>
          )}
          <Box>　　</Box>
          {checked.novel && (
            <Box>
              <Typography variant="h6">ノベルティ配布申込</Typography>

              <Typography>
                【ノベルティの配布に関する規約】
                <br />
                ・ノベルティ配布は各自の小間内で行う。
                <br />
                ・ノベルティ配布の際の封筒・手提げ袋などについては、節度を持ったデザイン・大きさとする。
                <br />
              </Typography>

              <Typography color="error">
                ※コピー商品など、商標権、知的所有権および財産権を侵害するものは厳禁となります。
              </Typography>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.novelty}
                    onChange={handleChange("novelty")}
                  />
                }
                label="上記規約を守り、実施いたします。"
                sx={{ mt: 1 }}
              />
            </Box>
          )}
          <Box>
            <Typography variant="h6">備考欄</Typography>
            <Typography color="error">※物品販売・アンケート・ノベルティ配布申込について補足事項等がある場合はコチラにご入力ください。</Typography>
            <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
          </Box>
        </>
      )}
        </FormGroup>
          <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
            <Typography>
              【上記入力内容についてのお問い合わせ先】<br />
              SDGs 子ども・ユースフェア2026出展者事務局（中部経済新聞社 事業部内）<br />
              担当：佐野、三宅<br />
              TEL:052-561-5675<br />
              入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
              ※お急ぎの場合はお電話にてお問い合わせください。
            </Typography>
          </Box>
        </Container>
    </Container>
    {!isCorpModal &&(
    <>
    <Container sx={{textAlign: 'center'}}>
        <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
            提出する
        </Button>
    </Container>
    <footer>
      <Typography>
        © 2026 THE MID-JAPAN ECONOMIST.
      </Typography>
    </footer>
    </>
    )}
    {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
    </>
)

};
export default Comp17Sub;
